//Import asset file(s) used by this module.
import ScreenNavigator from '../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator';
import '../../../assets/skins/LaptopAssets';

import AbstractInstaller from "../../core/application/AbstractInstaller";
import AppInstaller from '../../core/application/AppInstaller';
import SkinKeyRegistry from '../../core/ui/SkinKeyRegistry';
import EmailBoxSelectionMediator from '../email/view/EmailBoxSelectionMediator';
import EmailConversationListItemMediator from '../email/view/EmailConversationListItemMediator';
import EmailConversationListMediator from '../email/view/EmailConversationListMediator';
import EmailConversationMediator from '../email/view/EmailConversationMediator';
import EmailDraftInputComponentMediator from '../email/view/EmailDraftInputComponentMediator';
import EmailDraftItemMediator from '../email/view/EmailDraftItemMediator';
import EmailDraftOptionOverlayMediator from '../email/view/EmailDraftOptionOverlayMediator';
import EmailDraftSendComponentMediator from '../email/view/EmailDraftSendComponentMediator';
import EmailDraftSentInputComponentMediator from '../email/view/EmailDraftSentInputComponentMediator';
import EmailReceivedItemMediator from '../email/view/EmailReceivedItemMediator';
import FileExplorerItemMediator from '../files/view/FileExplorerItemMediator';
import FileExplorerMediator from '../files/view/FileExplorerMediator';
import FileViewerMediator from '../files/view/FileViewerMediator';
import LaptopNavigateCommand from './controller/LaptopNavigateCommand';
import LaptopSetupCommand from './controller/LaptopSetupCommand';
import LaptopSetupNavigatorCommand from './controller/LaptopSetupNavigatorCommand';
import LaptopNavigateEvent from './model/LaptopNavigateEvent';
import LaptopSetupEvent from './model/LaptopSetupEvent';
import LaptopSetupNavigatorEvent from './model/LaptopSetupNavigatorEvent';
import LaptopSkinKeyRegistry from './model/LaptopSkinKeyRegistry';
import LaptopMediator from './view/LaptopMediator';
import LaptopOpenerMediator from './view/LaptopOpenerMediator';
import LaptopEmailScreenMediator from './view/screens/email/LaptopEmailScreenMediator';
import LaptopFileExplorerScreenMediator from './view/screens/file-explorer/LaptopFileExplorerScreenMediator';
import LaptopFileViewerScreenMediator from './view/screens/file-explorer/LaptopFileViewerScreenMediator';
import LaptopMainScreenMediator from './view/screens/main-screen/LaptopMainScreenMediator';


export default class LaptopInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        // The opener uses the 'default' SkinKeyRegistry so that we can check if this skin key exists without having to import a laptop related module
        SkinKeyRegistry.LAPTOP_OPENER_MEDIATOR = this._mapMediator(LaptopOpenerMediator);

        LaptopSkinKeyRegistry.LAPTOP_MEDIATOR = this._mapMediator(LaptopMediator, createjs.Container);

        LaptopSkinKeyRegistry.LAPTOP_MAIN_SCREEN_SKIN = this._mapMediator(LaptopMainScreenMediator, lib.LaptopAssets.LaptopMainScreenSkin);

        LaptopSkinKeyRegistry.LAPTOP_FILE_EXPLORER_SCREEN_SKIN = this._mapMediator(LaptopFileExplorerScreenMediator, lib.LaptopAssets.LaptopFileExplorerScreenSkin);
        LaptopSkinKeyRegistry.FILE_EXPLORER_SKIN = this._mapMediator(FileExplorerMediator);
        LaptopSkinKeyRegistry.FILE_EXPLORER_ITEM_SKIN = this._mapMediator(FileExplorerItemMediator, lib.LaptopAssets.FileExplorerItem);

        LaptopSkinKeyRegistry.LAPTOP_FILE_VIEWER_SCREEN_SKIN = this._mapMediator(LaptopFileViewerScreenMediator, lib.LaptopAssets.LaptopFileViewerScreenSkin);
        LaptopSkinKeyRegistry.FILE_VIEWER_SKIN = this._mapMediator(FileViewerMediator);

        LaptopSkinKeyRegistry.LAPTOP_EMAIL_SCREEN_SKIN = this._mapMediator(LaptopEmailScreenMediator, lib.LaptopAssets.LaptopEmailScreenSkin);
        LaptopSkinKeyRegistry.EMAIL_BOX_SELECTION_SKIN = this._mapMediator(EmailBoxSelectionMediator);
        LaptopSkinKeyRegistry.EMAIL_CONVERSATION_LIST_SKIN = this._mapMediator(EmailConversationListMediator);
        LaptopSkinKeyRegistry.EMAIL_CONVERSATION_SKIN = this._mapMediator(EmailConversationMediator);

        LaptopSkinKeyRegistry.LAPTOP_EMAIL_DRAFT_OPTION_OVERLAY_SKIN = this._mapMediator(EmailDraftOptionOverlayMediator, lib.LaptopAssets.LaptopEmailDraftOptionOverlaySkin);

        LaptopSkinKeyRegistry.EMAIL_RECEIVED_ITEM_SKIN = this._mapMediator(EmailReceivedItemMediator, lib.LaptopAssets.EmailReceivedItemSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_ITEM_SKIN = this._mapMediator(EmailDraftItemMediator, lib.LaptopAssets.EmailDraftItemSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_TEXT_COMPONENT_SKIN = this._mapMediator(null, lib.LaptopAssets.EmailDraftTextComponentSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_INPUT_COMPONENT_SKIN = this._mapMediator(EmailDraftInputComponentMediator, lib.LaptopAssets.EmailDraftInputComponentSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_SENT_INPUT_COMPONENT_SKIN = this._mapMediator(EmailDraftSentInputComponentMediator, lib.LaptopAssets.EmailSentPlayerTextSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_INPUT_SELECTION_COMPONENT_SKIN = this._mapMediator(EmailDraftInputComponentMediator, lib.LaptopAssets.EmailDraftInputSelectionComponentSkin);
        LaptopSkinKeyRegistry.EMAIL_INDICATOR_BUTTON = this._mapMediator(EmailConversationListItemMediator, lib.LaptopAssets.EmailConversationListItemSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_SEND_COMPONENT_SKIN = this._mapMediator(EmailDraftSendComponentMediator, lib.LaptopAssets.EmailDraftSendComponentSkin);
        LaptopSkinKeyRegistry.EMAIL_DRAFT_OPTION_OVERLAY_BUTTON_SKIN = this._mapMediator(null, lib.LaptopAssets.EmailDraftOptionOverlayOptionButtonSkin);

        this._setupNavigator(injector);

        commands.add(LaptopSetupNavigatorEvent.PERFORM, LaptopSetupNavigatorCommand);

        commands.add(LaptopNavigateEvent.OPEN_SCREEN_REQUEST, LaptopNavigateCommand);
        commands.add(LaptopNavigateEvent.GOTO_SCREEN_REQUEST, LaptopNavigateCommand);
        commands.add(LaptopNavigateEvent.CLOSE_SCREEN_REQUEST, LaptopNavigateCommand);
        commands.add(LaptopNavigateEvent.CLOSE_ALL_SCREENS_REQUEST, LaptopNavigateCommand);
        commands.add(LaptopNavigateEvent.POP_UP_REQUEST, LaptopNavigateCommand);
        commands.add(LaptopNavigateEvent.CLOSE_POP_UP_REQUEST, LaptopNavigateCommand);

        commands.add(LaptopSetupEvent.PERFORM, LaptopSetupCommand);

        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "LaptopAssets");
    }

    _setupNavigator(injector) {
        const dispatcher = this._getValue("dispatcher");
        const screenNavigator = new ScreenNavigator(new createjs.Container(), dispatcher);
        injector.mapValue("laptopScreenNavigator", screenNavigator);
    }
}